import React, { useMemo } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { IconButton, Tooltip } from '@mui/material';
import { MdDelete, MdSave } from 'react-icons/md';
import { useSelector } from 'react-redux';

const SeriviceTable = ({setEditMode,onDeleteServices,setServicetoedit}) => {
    const selector = useSelector(state=>state.business);
    const selectorAuth = useSelector(state=>state.auth);

    const handleClickDelete = (id) =>{
      onDeleteServices(id);
    }
    const handleClickEdit = (data) =>{
      const req = {
        service_id:data.service_id,
        business_id:data.business_id
      }
      setServicetoedit(req)
    }

    const columnDefs = useMemo(() => [
      {
        field: 'service',
        headerName: 'Service',
        flex: 1,
        minWidth: 150
      },
      {
        field: 'charges',
        headerName: 'Charges',
        flex: 1,
        minWidth: 120
      },
      {
        field: 'actions',
        headerName: 'Actions',
        width: 150,
        cellRenderer: (params) => {
          return (
            <div className='flex items-center gap-2 justify-end'>
              <Tooltip title='Save Details of service' placement='top'>
                <IconButton size="small">
                  <MdSave />
                </IconButton>
              </Tooltip>
              <Tooltip title='Delete service' placement='top'>
                <IconButton size="small" onClick={() => handleClickDelete(params.data?.service_id)}>
                  <MdDelete />
                </IconButton>
              </Tooltip>
            </div>
          );
        },
        sortable: false,
        filter: false
      }
    ], []);

    const defaultColDef = useMemo(() => ({
      sortable: true,
      filter: true,
      resizable: true
    }), []);

  return (
    <div className="ag-theme-alpine" style={{ height: '400px', width: '100%', padding: '16px' }}>
      <AgGridReact
        rowData={selector?.services || []}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        pagination={true}
        paginationPageSize={10}
        animateRows={true}
      />
    </div>
    // <div className='table-wrapper'>
    //     <div className='table-container'>
    //         <div className='td-head lg:w-full justify-between'>
    //         {
    //           selectorAuth?.user?.role==='supper_admin'??
    //           <p className='td-element'>Id</p>
    //         }
    //         <p className='td-element'>Service Name</p>
    //         <p className='td-element'>Service Charge</p>
    //         {/* <p className='td-element'>Email</p> */}
    //         <p className='td-element'>Action</p>
    //         </div>
    //         <div className='flex-1'>
    //         {
    //             // JSON.stringify(selector?.data)
    //             // selector?.data?.map((element,i)=><p key={i}>hi</p>)
    //             selector?.services?.map(
    //                 (e,i)=>
    //         <div className='td-row lg:w-full justify-between' key={i}>
    //        {
    //         selectorAuth?.user?.role==='supper_admin'??
    //          <p className='td-element highlited'><Link to={'/business/'+e?.service_id}>{e?.business_id}</Link></p>
    //        }
    //         <p className='td-element'>{e?.service}</p>
    //         <p className='td-element'>{e?.charges}</p>
    //         {/* <p className='td-element'>{e?.email}</p>
    //         <p className='td-element'>
    //             <button onClick={()=>{}}>{e?.restrict === 0?'Restrict':'Unrestrict'} </button>
    //         </p> */}
    //         <p className="td-element">
    //               <span className="flex gap-4 justify-center items-center">
    //                 <AiFillEdit
    //                   className="cursor-pointer"
    //                   onClick={()=>setEditMode(e)}
    //                 />
    //                 <MdDelete color='red'/>
    //               </span>
    //             </p>
    //         </div>
    //             )
    //         }
    //         </div>
    //     </div> 
    // </div>
  )
}

export default SeriviceTable